/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import { environment } from './environments/environment';

export function getBaseUrl() { 
  return document.getElementsByTagName('base')[0].href;
}
declare var angConfig: any;
 
const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl },
  { provide: 'myconfig', useValue: angConfig }
];
//tests
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));
